import { render, staticRenderFns } from "./ExamAudio.vue?vue&type=template&id=037ee24e"
import script from "./ExamAudio.vue?vue&type=script&lang=js"
export * from "./ExamAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports